import InputFormStyle from "../style/input_form.component";
import { InputFormProps } from "./interface/formInterface";

const FormNumber = (props: InputFormProps) => {
  const { value, setValue, label, width } = props;
  return (
    <div style={{ width: width, marginTop: "10px" }}>
      {value !== "" ? (
        <label style={{ color: "white", fontSize: "12px" }}>{label}</label>
      ) : (
        <label style={{ color: "#1E1E1E", fontSize: "12px" }}>{label}</label>
      )}
      <InputFormStyle
        width="100%"
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        placeholder={label}
        type="number"
      ></InputFormStyle>
    </div>
  );
};

export default FormNumber;
